/** @jsx jsx */
import { jsx } from 'theme-ui';
import View from '../View/View';

export default function Row(props) {
  return (
    <View
      sx={{ display: 'flex', flexWrap: 'wrap', marginX: '-gutter' }}
      {...props}
    />
  );
}
